import type { ShipmentStage } from '#/entities/shipment'

export const MASS_CHANNEL = {
  sms: 'sms',
  email: 'email',
  phone: 'phone',
} as const

export type MassChannel = (typeof MASS_CHANNEL)[keyof typeof MASS_CHANNEL]

export const MASS_STATUS = {
  idle: 'idle',
  sending: 'sending',
  dialing: 'dialing',
  onCall: 'onCall',
  incoming: 'incoming',
  calling: 'calling',
  ended: 'ended',
} as const

export type MassStatus = (typeof MASS_STATUS)[keyof typeof MASS_STATUS]

export interface IdleState {
  status: typeof MASS_STATUS.idle
}

export interface ProgressState {
  status: typeof MASS_STATUS.sending | typeof MASS_STATUS.dialing
  done: number
  total: number
  queue: number
  startedAt: number
  paused: boolean
  jobId?: string
}

export interface OnCallState {
  status: typeof MASS_STATUS.onCall
  contactName: string
  contactNumber: string
  startedAt: number
  matches: CallMatch[]
}

export interface CallMatch {
  id?: string
  stage?: ShipmentStage
  statusLabel: string
  title: string
  route: string
  code: string
  total: string
}

/** Present when the caller's number is one of the org's own shared (mainline)
 *  numbers; `label` is its friendly name from telephony settings, or `null`. */
export interface CallMainline {
  label: string | null
}

export interface IncomingState {
  status: typeof MASS_STATUS.incoming
  contactName: string
  contactNumber: string
  matches: CallMatch[]
}

export interface CallingState {
  status: typeof MASS_STATUS.calling
  contactName: string
  contactNumber: string
  matches: CallMatch[]
}

export interface EndedState {
  status: typeof MASS_STATUS.ended
  contactName: string
  contactNumber: string
  matches: CallMatch[]
}

export type ChannelState =
  | IdleState
  | ProgressState
  | OnCallState
  | IncomingState
  | CallingState
  | EndedState

export const IDLE: IdleState = { status: MASS_STATUS.idle }
